import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import axios from "axios";

import Loader from "../../components/Loading/Loader";
import { AddHeader } from "../../components/AddHeader";
import { ExerciseTypeMark } from "../../components/ExerciseTypeMark";
import { ExerciseAddLayout } from "./ExerciseAddLayout";
import { complist } from "../../components/funtionsBD/Mainservice";
import { ip_back } from "../../config";
import { currentAppLanguage } from "../../utils/appLanguages";
import { competencyBlockIconSrc } from "../../utils/competencyBlockIcon";

export const Eincb3 = () => {
  const [list, setlist] = useState([]);
  const [allBlocks, setAllBlocks] = useState([]);
  const [showAllBlocks, setShowAllBlocks] = useState(false);
  const [error, seterror] = useState();
  const [load, setload] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const { t } = useTranslation();
  const currentlng = currentAppLanguage();

  const hasSessionAndGroup = data.sessionid && data.grpid;

  useEffect(() => {
    typelist();
  }, [data.sessionid, data.grpid]);

  const typelist = async () => {
    setload(true);
    seterror("");
    setlist([]);
    setAllBlocks([]);

    let blocks = [];
    try {
      const response = await complist();
      blocks = response.data.data || [];
      setAllBlocks(blocks);
    } catch (err) {
      console.error(err);
      seterror(err?.message || "Failed to load competency blocks");
      setload(false);
      return;
    }

    if (hasSessionAndGroup) {
      try {
        const recResponse = await axios.post(
          `${ip_back}api/exercises/recommend-competency-blocks-for-session`,
          {
            ts_id: data.sessionid,
            gr_id: data.grpid,
            language: currentlng?.substring(0, 2) || "en",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (recResponse.data.status === "success" && recResponse.data.data?.competency_blocks?.length > 0) {
          setlist(recResponse.data.data.competency_blocks);
        } else {
          setlist(blocks);
        }
      } catch (err) {
        console.error("Recommend competency blocks error:", err);
        setlist(blocks);
      }
    } else {
      setlist(blocks);
    }
    setload(false);
  };

  const displayList = showAllBlocks ? allBlocks : list;
  const hasRecommended = hasSessionAndGroup && list.length > 0 && list.length < allBlocks.length;

  return (
    <ExerciseAddLayout>
      <AddHeader title={t("addex")} />
      <p className="exercise_type_define exadd-crumb">
        {data.type} {data.subtype ? `· ${data.subtype}` : ""}
      </p>
      {hasRecommended && (
        <div className="exercise-add-recommend-row">
          <span className="exercise-add-recommend-row__hint">
            {t("recommendedForGroup") || "Recommended for your group (level & goals)"}
          </span>
          <button
            type="button"
            className="exercise-add-toggle-btn"
            onClick={() => setShowAllBlocks(!showAllBlocks)}
          >
            {showAllBlocks ? (t("showRecommended") || "Show recommended") : (t("showAllBlocks") || "Show all blocks")}
          </button>
        </div>
      )}
      <div className="exercise_session_div exadd-choices">
        {displayList?.map((i, index) => {
          const blockIcon = competencyBlockIconSrc(i);
          return (
          <button
            type="button"
            className="session_add_box exadd-choice"
            key={i.cb_id || index}
            onClick={() =>
              navigate("/Exerciseslist", {
                state: {
                  subtypeid: data.id,
                  subtype: data.subtype,
                  type: data.type,
                  typeid: data.typeid,
                  cb: i[`cb_name_${currentlng}`] || i.name,
                  cbid: i.cb_id,
                  sessionid: data.sessionid,
                  grpid: data.grpid,
                  tsg_id: data.tsg_id,
                  te_id: data.te_id,
                },
              })
            }
          >
            <div
              className={`session-image-add2 exadd-choice__icon${
                blockIcon ? " exadd-choice__icon--mark" : ""
              }`}
              aria-hidden="true"
            >
              {blockIcon ? (
                <ExerciseTypeMark src={blockIcon} />
              ) : (
                <img src={ip_back + "SubtypeImage/competency_block.png"} alt="" />
              )}
            </div>
            <div className="session-addinfo exadd-choice__copy">
              <h3>{i[`cb_name_${currentlng}`] || i.name} </h3>
            </div>
          </button>
          );
        })}
      </div>
      <p className="select_msg">{error}</p>
      {load && <Loader />}
    </ExerciseAddLayout>
  );
};
